<template>
  <div class="article">
    <div class="article__elements">
      <Cross class="mobile-hidden" img-width="10rem" top="20.3rem" left="24.2rem" color="orange" />
      <Cross class="mobile-hidden" img-width="4.2rem" top="47.8rem" left="67.1rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="7.5rem" top="27.5rem" left="4.4rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="4rem" top="21rem" left="67.5rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="8rem" top="24.5rem" right="11.6rem" color="orange" />
      <Snowflake3 class="mobile-hidden" img-width="5.5rem" bottom="25rem" right="8.8rem" color="orange" />
      <Gift3 class="mobile-hidden" img-width="7.5rem" top="39.2rem" left="16.5rem" />
      <Gift4 class="mobile-hidden" img-width="11.3rem" bottom="9.4rem" right="16rem" />
      <Tree2 class="mobile-hidden" img-width="9.8rem" bottom="6.2rem" left="56rem" />
    </div>

    <div class="article__img article__img--1">
      <img class="mobile-hidden" src="@/assets/img/article1.png" alt="">
      <img class="mobile-visible" src="@/assets/img/article1-mob.png" alt="">
    </div>
    <div class="article__content">
      <h2 class="article__title">
        {{ 'Новогодние добровольцы' | typograf }}
      </h2>
      <h2 class="article__title">
        {{ 'Как найти доброе дело по душе' | typograf }}
      </h2>
      <p class="article__subtitle">
        {{ 'В 2021 году волонтерское движение в России достигло огромных масштабов. Волонтерство может быть разным, и стать его частью теперь как никогда просто.' | typograf }}
      </p>
      <p class="article__text">
        {{ 'Акция «Новый год в каждый дом» уже стартовала по всей России, и присоединиться к ней может каждый желающий. О том, как влиться в движение #МЫВМЕСТЕ накануне Нового года и выбрать для себя доброе дело, — в специальном материале «Ленты.ру».' | typograf }}
      </p>
      <div class="article__button-box">
        <a href="https://lenta.ru/articles/2021/12/17/volonternovygod/" target="_blank">
          <button @click="gtmSend" class="button button--orange">Читать специальный материал</button>
        </a>
      </div>

      <ArticleFooter />
    </div>
  </div>
</template>

<script>
  import './article.scss'
  import Cross from "../Elements/Cross";

  import Snowflake2 from "../Elements/Snowflake2";
  import ArticleFooter from "../ArticleFooter/ArticleFooter";
  import Gift3 from "../Elements/Gift3";
  import Tree2 from "../Elements/Tree2";
  import Snowflake3 from "../Elements/Snowflake3";
  import Gift4 from "../Elements/Gift4";
  export default {
    name: "Article",
    components: {Gift4, Snowflake3, Tree2, Gift3, ArticleFooter, Snowflake2, Cross},
    methods: {
      gtmSend() {
        window.gtag('event', 'click', {
          'event_category': 'ch7_link_lenta_ru',
          'event_label': 'chapter_7'
        });
        window.ym(86974684, 'reachGoal', 'ch7_link_lenta_ru/click/chapter_7');
      }
    }
  }
</script>

<style scoped>

</style>
